export const GenreFilter = ({ genres, selectedGenre, onGenreChange }) => {
  return (
    <div className="flex flex-wrap gap-3" data-testid="genre-filter">
      <button
        onClick={() => onGenreChange(null)}
        className={`genre-filter ${!selectedGenre ? 'active' : ''}`}
        data-testid="genre-filter-all"
      >
        Todos
      </button>
      {genres.map((genre) => (
        <button
          key={genre.value}
          onClick={() => onGenreChange(genre.value)}
          className={`genre-filter ${selectedGenre === genre.value ? 'active' : ''}`}
          data-testid={`genre-filter-${genre.value}`}
        >
          {genre.label}
        </button>
      ))}
    </div>
  );
};

export default GenreFilter;
